import React from "react";
import logo from "../../assets/logo.svg";
import background from "../../assets/bg.jpg";
import backgroundIPhone from "../../assets/bg_iphone.jpg";
import { Link } from "react-router-dom";
import { BRAND } from "../../environment";

export const TimeOutPage = () => {
  return (
    <>
      <div className="hidden md:flex text-center use-normal font-sans text-lg">
        <nav
          className=" w-[333px] text-white h-[100vh] flex flex-col text-center items-center"
          style={{
            backgroundImage: `url(${background})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <img src={logo} alt="logo" className="h-[85px] mt-32" />
          <h2 className="font-semibold font-sm mt-12 text-[22px] w-[90%] text-center">
            Welcome to the next generation diagnosis
          </h2>
        </nav>
        <div className="flex justify-center flex-col items-left pl-[120px] w-[100%]">
          <h3
            data-testid="session-expired"
            className="font-semibold text-left w-[50%] text-[17px] mb-3 text-primary-4"
          >
            Your session has expired
          </h3>
          <p className="text-base font-rubik font-normal text-left w-[50%]">
            Too long time with no activity, you can access to your {BRAND.NAME}{" "}
            account following the link
          </p>
          <Link
            to="/login"
            className="border w-[171px] py-1 mt-7 text-center text-white font-semibold text-base rounded-2xl bg-primary-1 active:bg-[#7DBEEA] disabled:bg-[#E5E5E5] disabled:text-[#727272] disabled:cursor-not-allowed"
          >
            Login again
          </Link>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${backgroundIPhone})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="w-full h-[100vh] md:hidden"
      >
        <div className="flex flex-col items-center h-full justify-center">
          <img src={logo} className="w-[69px] h-[92px]" alt="logo" />
          <h3 className="text-xl text-white mt-6 font-semibold">
            Your session has expired
          </h3>
          <p className="text-base mt-4 font-rubik font-normal text-center w-3/4">
            Too long time with no activity, you can access to your {BRAND.NAME}
            following the link
          </p>
          <Link
            to="/login"
            className="text-base mt-8 rounded-[12px] text-white w-[90%] text-center py-3 bg-[#338CC7] active:bg-[#7DBEEA] disabled:bg-[#E5E5E5] disabled:text-[#727272] disabled:cursor-not-allowed"
          >
            Login again
          </Link>
        </div>
      </div>
    </>
  );
};
